import { Text } from "@/components/ui/baseUi/text"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/baseUi/tooltip"
import { cn } from "@/modules/lib/utils"
import { shortenText } from "@/modules/utils/stringUtils"
import { QuadBoxIcon } from "@images/svgIcons/quadBoxIcon"
import { BoxRestrictionsComponent } from "@modules/boxProgrammation/components/boxRestrictionsComponent"
import { useBoxProgram } from "@modules/boxProgrammation/hooks/useBoxProgram"

type BoxProgramInfoResumeProps = {
  boxProgramId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxProgramInfoResume({ boxProgramId, className, ...props }: BoxProgramInfoResumeProps) {
  const { data: boxProgrammation } = useBoxProgram(boxProgramId)

  return (
    <div className={cn("flex grow flex-col", className)} {...props}>
      <div className="flex h-60 w-full overflow-hidden rounded-b-4xl">
        <div className="flex w-5/10 flex-row items-center gap-2 pl-6">
          <QuadBoxIcon className="shrink-0" color={boxProgrammation.color} />
          {boxProgrammation.name.length > 90 ? (
            <Tooltip>
              <TooltipTrigger>
                <Text fontStyle="HS">{shortenText(boxProgrammation.name, 90)}</Text>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="w-fit max-w-60 wrap-break-word whitespace-normal">
                {boxProgrammation.name}
              </TooltipContent>
            </Tooltip>
          ) : (
            <Text fontStyle="HS" className="wrap-break-word whitespace-break-spaces">
              {boxProgrammation.name}
            </Text>
          )}
        </div>
        <div
          className="relative h-full w-5/10 grow bg-cover bg-center"
          style={{
            backgroundImage: `url(${boxProgrammation.image?.url})`,
            clipPath: "polygon(41% 0, 100% 0, 100% 1000%, 0% 125%)",
          }}
        >
          <div
            className="absolute inset-0 z-1 h-full"
            style={{
              background: `color-mix(in oklch, ${boxProgrammation.color} 70%, transparent)`,
            }}
          />
        </div>
      </div>

      <div className="flex w-full flex-col gap-4 px-5 py-8">
        <Text fontStyle="BM" className="wrap-anywhere whitespace-break-spaces">
          {boxProgrammation.description}
        </Text>
        <BoxRestrictionsComponent boxProgramId={boxProgrammation.id} />
      </div>
    </div>
  )
}
